<template>
  <div style="height: 100%">
    <base-table-drawer
      ref="tableDrawer"
      handler="brandOrField"
      :actionReload="true"
      :toolbar="toolbar"
      :columns="columns"
      :formItems="formItems"
      :formAttrs="formAttrs"
      :beginAddBefor="beginAddBefor"
      :rules="rules"
      :sendJson="true"
    ></base-table-drawer>
    <field-add-dialog
      v-if="showEditCell"
      v-model="showEditCell"
      :baseObj="baseObj"
      @editSuccess="editSuccess"
      @closeDiag="showEditCell = false"
    ></field-add-dialog>
  </div>
</template>
<script>
export default {
  name: 'brand-manage',
  data() {
    return {
      userArr: [],
      showEditCell: false,
      baseObj: {},
      baseFormItem: {
        label: '引用数据列',
        prop: 'relBrand',
        component: 'form-select1',
        bind: {
          param: {
            data_type: 1,
          },
          sendJson: true,
          dataKey: {
            label: 'brand',
            value: 'id',
          },
        },
      },
      formAttrs: {
        labelWidth: '90px',
      },
      formItems: [
        {
          label: '查询类型',
          prop: 'type',
          component: 'form-select1',
          bind: {
            options: this.$getOptions('queryType'),
          },
          on: {
            change: this.queryTypeChange,
          },
        },
        {
          label: '语言',
          prop: 'lang',
          component: 'form-select',
          bind: {
            options: this.$getOptions('lang'),
          },
        },
        {
          label: '诊断包ID',
          prop: 'packid',
        },
        {
          label: '类别名称',
          prop: 'brand',
        },
        // {
        //     label: "品牌描述",
        //     prop: "name",
        // },
        // {
        //     label: "引用品牌列",
        //     prop: "relBrand",
        //     component:"form-select1",
        //     bind:{
        // 		param:{
        //             data_type:1
        //         },
        //         sendJson:true,
        // 		dataKey:{
        // 			label:'brand',
        // 			value:'id'
        // 		},
        // 	},
        // },
      ],
      rules: {
        type: [
          {
            required: true,
            message: '请选择查询类型',
            trigger: 'change',
          },
        ],
        lang: [
          {
            required: true,
            message: '请选择语言',
            trigger: 'change',
          },
        ],
        packid: [
          {
            required: true,
            message: '请输入诊断包ID',
            trigger: 'blur',
          },
        ],
        brand: [
          {
            required: true,
            message: '请输入类别名称',
            trigger: 'blur',
          },
        ],
      },
      toolbar: {
        formItems: [
          {
            label: '查询类型',
            prop: 'type',
            component: 'form-select',
            bind: {
              style: 'width: 140px',
              clearable: true,
              options: this.$getOptions('queryType'),
            },
          },
          {
            label: '语言',
            prop: 'lang',
            component: 'form-select',
            bind: {
              style: 'width: 100px',
              clearable: true,
              options: this.$getOptions('lang'),
            },
          },
          {
            label: '类别名称',
            prop: 'brand',
            bind: {
              style: 'width: 140px',
            },
          },
        ],
        query: {
          // SortFields: [
          //     {
          //     Field: "Name",
          //     Order: 1,
          //     },
          // ],
          data_type: 2,
        },
      },
      columns: [
        {
          bind: {
            type: 'expand',
          },
          default: {
            component: 'table-expand-data',
            bind: {},
            on: {},
          },
        },
        {
          bind: {
            label: '查询类型',
            prop: 'type',
          },
          default: {
            component: 'cell-text',
            bind: {
              formatter(scope, cellValue) {
                return this.$store.state.queryType[cellValue] || '其他'
              },
            },
          },
        },
        {
          bind: {
            label: '类别名称',
            prop: 'brand',
          },
        },
        {
          bind: {
            label: '诊断包ID',
            prop: 'packid',
          },
        },
        {
          bind: {
            label: '语言',
            prop: 'lang',
          },
        },
        // {
        //     bind: {
        //         label: "语言",
        //         prop: "lang",
        //     },
        // },
        {
          bind: {
            label: '创建人',
            prop: 'cre_user',
          },
        },
        {
          bind: {
            label: '创建时间',
            prop: 'cre_time',
          },
        },
        {
          rightbar: true,
          bind: {
            label: '操作',
            prop: 'oper',
            width: 180,
          },
          header: {
            component: 'cell-button',
            bind: { label: '新建', icon: 'el-icon-plus', type: 'primary' },
            on: {
              click: () => {
                this.formItems[0].bind.disabled = false
                if (
                  this.formItems[this.formItems.length - 1].prop != 'relBrand'
                ) {
                  this.formItems.splice(this.formItems.length, 0, {
                    ...this.baseFormItem,
                  })
                }
                this.$refs.tableDrawer.beginAdd()
              },
            },
          },
          default: {
            component: 'CellDropdown',
            bind: {
              dropdowns: [
                {
                  label: '编辑数据列',
                  click: (scope) => {
                    this.showEditCell = true
                    this.baseObj = JSON.parse(JSON.stringify(scope.row))
                  },
                },
                {
                  label: '修改',
                  click: (scope) => {
                    this.formItems[0].bind.disabled = true
                    if (
                      this.formItems[this.formItems.length - 1].prop ==
                      'relBrand'
                    ) {
                      this.formItems.splice(this.formItems.length - 1, 1)
                    }
                    this.$refs.tableDrawer.beginEdit(scope)
                  },
                },
                {
                  label: '删除',
                  click: this.delData,
                },
              ],
            },
          },
        },
      ],
    }
  },
  mounted() {
    //加一个其他类型  方便扩展其他列表查询
    this.formItems[0].bind.options.push({
      label: '其他',
      value: '其他',
    })
    this.toolbar.formItems[0].bind.options = this.formItems[0].bind.options
  },
  computed: {
    drawer() {
      return this.$refs.tableDrawer
    },
  },
  methods: {
    // responseHandler(resp){
    //     if (resp.data.code == 0) {
    //         var data=resp.data.data.Data || [];
    //         var pageSize=resp.data.data.Total || 0;
    //         var uids=[];
    //         for(var obj of data){
    //             if(obj.uid){
    //                 uids.push(obj.uid);
    //             }
    //         }
    //         var tableDataObj={
    //             total: pageSize,
    //             rows: data,
    //         }

    //         this.queryUserInfo(uids,tableDataObj);
    //     } else {
    //         this.$message(resp.data.msg || '服务端返回数据异常');
    //     }
    // },
    beginAddBefor(callBack) {
      var that = this
      var obj = {
        cre_user: that.$root.getNickName(),
        data_type: 1,
      }
      callBack(obj)
    },
    queryTypeChange(obj) {
      var that = this
      //var relBrandSelect=that.$refs.tableDrawer.$refs.drawer.$refs.drawerForm.$refs.form.$children[2].$children[1];
      // this.formItems[2].bind.url="/brandOrField/get";
      // this.formItems[2].bind.param.type=obj.val;
      if (this.formItems[this.formItems.length - 1].prop == 'relBrand') {
        var baseFormItemNew = { ...this.baseFormItem }
        baseFormItemNew.bind.url = '/brandOrField/get'
        baseFormItemNew.bind.param.type = obj.val
        this.formItems.splice(this.formItems.length - 1, 1)
        this.$nextTick(() => {
          this.formItems.splice(this.formItems.length, 0, baseFormItemNew)
          this.formItems[0].value = obj.val
        })
      }
      // relBrandSelect.url="/brandOrField/get";
      // relBrandSelect.param.type=obj.val;
      // relBrandSelect.queryAllCategory();
    },
    editSuccess() {
      this.drawer.$refs.table.refreshData()
    },
    delData(scope) {
      if (confirm('确定删除类别【' + scope.row.brand + '】?')) {
        this.$postObj('/brandOrField/remove', scope.row)
          .then((resp) => {
            if (resp.data.code == 0) {
              this.drawer.$refs.table.delRow(scope.row)
            } else {
              console.error(resp)
              this.$message(
                resp.data.msg || this.$getMsg(resp.data.code, '服务端处理失败')
              )
            }
          })
          .catch((error) => {
            // 请求失败处理
            console.error(error)
            this.$message('请求发生错误！')
          })
      }
    },
  },
}
</script>